import React from 'react'
import MainLayout from '../../layout/MainLayout'
import AddBlogForm from '../../components/blogs/AddBlogForm'

const AddBlogPage = () => {
  return (
    <MainLayout>
        <AddBlogForm />
    </MainLayout>
  )
}

export default AddBlogPage